<div class="bp-modal mod-lg start-customer-segmentation">
	<div class="bp-modal-body">
		<img
			class="start-customer-segmentation_image"
			[src]="'/assets/images/almost-done.svg'"
			[alt]="'almost_there' | translate" />
		<div class="start-customer-segmentation_title">{{ "almost_there" | translate }}</div>
		<div class="start-customer-segmentation_notification">
			As part of UK regulations, you’ll now enter a <strong>24-hour cooling-off period</strong> to reflect on whether you wish to proceed with investing. You won’t be able to trade during this period.
		</div>
		<div class="action-buttons">
			<button
				class="btn btn-primary btn-wide"
				(click)="confirm()">
				{{ "save_and_continue" | translate }}
			</button>
		</div>
	</div>
</div>